import { LocalStorage } from "quasar";
const url_base = import.meta.env.VUE_API;
const fetch_data = (url_enpoint = "", method = "GET", body_body) => {
  if (url_enpoint.length > 0) {

    const token = LocalStorage.getItem("access_token");
    if (method == "GET" || method == "DELETE") {
      const response = fetch(url_enpoint, {
        method: method,
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "X-XSRF-TOKEN": token,
          "Authorization": `Bearer ${token}`,
          "Access-Control-Allow-Credentials": true
        },
        credentials: "include",
      });
      return response;
    } else if (method == "POST" || method == "PUT" || method == "PATCH") {
      const response = fetch(url_enpoint, {
        method: method,
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "X-XSRF-TOKEN": token,
          "Authorization": `Bearer ${token}`,
          "Access-Control-Allow-Credentials": true
        },
        credentials: "include",
        body: JSON.stringify(body_body),
      });

      return response;
    }

    return "method not allowed";
  }
  return "the url cannot be empty";
};

export default function fetch_request(
  url_enpoint = "",
  method = "GET",
  body = {}
) {
  
  if (method == "GET") {
    const response = fetch_data(url_base + url_enpoint, "GET", body)
      .then((data) => {
        // console.log(data);
        return data.json();
      })
      .catch((error) => {
        // console.error(error);
        return error.json();
      });
    return response;
  } else if (method == "POST") {
    const response = fetch_data(url_base + url_enpoint, "POST", body)
      .then((data) => {
        // console.log(data);
        return data.json();
      })
      .catch((error) => {
        // console.error(error);
        return error.json();
      });
    return response;
  } else if (method == "PUT") {
    const response = fetch_data(url_base + url_enpoint, "PUT", body)
      .then((data) => {
        // console.log(data);
        return data.json();
      })
      .catch((error) => {
        // console.error(error);
        return error.json();
      });
    return response;
  } else if (method == "PATCH") {
    const response = fetch_data(url_base + url_enpoint, "PATCH", body)
      .then((data) => {
        // console.log(data);
        return data.json();
      })
      .catch((error) => {
        // console.error(error);
        return error.json();
      });
    return response;
  } else if (method == "DELETE") {
    const response = fetch_data(url_base + url_enpoint, "DELETE", body)
      .then((data) => {
        // console.log(data);
        return data.json();
      })
      .catch((error) => {
        // console.error(error);
        return error.json();
      });
    return response;
  }
}
